// Mock data for PowerX UPS & Inverter brand website

export const BRAND = {
  name: 'PowerX',
  tagline: 'Power Your World',
  logoUrl:
    'https://customer-assets.emergentagent.com/job_powerx-solutions/artifacts/qx85emlj_UPS.jpg',
};

export const WHATSAPP = {
  number: '628123456789',
  displayNumber: '+62 812 3456 789',
  message:
    'Halo PowerX, saya ingin bertanya tentang produk UPS/Inverter Anda.',
  hours: 'Senin – Sabtu, 08:00 – 17:00 WIB',
};

// Image atlas – gambar produk sudah di-rehost ke Emergent Object Storage
// dan disajikan lewat backend /api/images/<path>. URL absolut disusun dari
// REACT_APP_BACKEND_URL agar sama di preview & produksi.
const CDN =
  (process.env.REACT_APP_BACKEND_URL || '').replace(/\/$/, '') +
  '/api/images/powerx/catalog';

const IMG = {
  // UPS Line Interactive LED (EAST-LED)
  ups_led_600: `${CDN}/ups_led_600.jpg`,
  ups_led_800: `${CDN}/ups_led_800.jpg`,
  ups_led_1200: `${CDN}/ups_led_1200.jpg`,
  ups_led_1500: `${CDN}/ups_led_1500.jpg`,
  // UPS Line Interactive LCD (EAST-LCD)
  ups_lcd_2000: `${CDN}/ups_lcd_3000.jpg`,
  ups_lcd_3000: `${CDN}/ups_lcd_3000.jpg`,
  // UPS Online LCD (EAST-LCD Online)
  ups_online_2000: `${CDN}/ups_online_2000.jpg`,
  ups_online_3000: `${CDN}/ups_online_3000.jpg`,
  // UPS Online Rack / Tower
  ups_rack_3k: `${CDN}/ups_rack_3k.jpg`,
  ups_tower_6k: `${CDN}/ups_tower_6k.jpg`,
  // Mini UPS
  mini_ups_epw: `${CDN}/mini_ups_epw.jpg`,
  mini_ups_505: `${CDN}/mini_ups_505.jpg`,
  // Battery (Lead Acid & AGM dari i-powerx; LiFePO4 belum di-rehost)
  battery_lead: `${CDN}/battery_lead.jpg`,
  battery_agm: `${CDN}/battery_agm.jpg`,
  battery_lifepo4:
    'https://images.unsplash.com/photo-1633419461186-7d40a38105ec?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDk1ODB8MHwxfHNlYXJjaHwxfHxsaXRoaXVtJTIwYmF0dGVyeXxlbnwwfHx8fDE3ODA3MjQ4Mjh8MA&ixlib=rb-4.1.0&q=85',
  // Inverter Pure Sine Wave (dari i-powerx)
  inverter_psw: `${CDN}/inverter_psw.jpg`,
  inverter_psw_alt: `${CDN}/inverter_psw_alt.jpg`,
  // Inverter fallback (belum ada di katalog i-powerx)
  inverter_hybrid:
    'https://images.unsplash.com/photo-1713544123641-5328f51964e4?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA3MDB8MHwxfHNlYXJjaHwxfHxpbnZlcnRlcnxlbnwwfHx8fDE3ODA3MjQ4MjF8MA&ixlib=rb-4.1.0&q=85',
  inverter_off:
    'https://images.unsplash.com/photo-1497366754035-f200968a6e72?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDk1Nzl8MHwxfHNlYXJjaHwyfHxtb2Rlcm4lMjBvZmZpY2V8ZW58MHx8fHwxNzgwNzI0ODM0fDA&ixlib=rb-4.1.0&q=85',
  inverter_on:
    'https://images.unsplash.com/photo-1497366811353-6870744d04b2?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDk1Nzl8MHwxfHNlYXJjaHwxfHxtb2Rlcm4lMjBvZmZpY2V8ZW58MHx8fHwxNzgwNzI0ODM0fDA&ixlib=rb-4.1.0&q=85',
  // Solar
  solar:
    'https://images.pexels.com/photos/9875416/pexels-photo-9875416.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940',
  solar_alt:
    'https://images.pexels.com/photos/9875440/pexels-photo-9875440.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940',
  // Smart Solar Lighting – reuse solar stock photos (foto asli akan menyusul)
  ssl_aio: 'https://images.pexels.com/photos/9875440/pexels-photo-9875440.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940',
  ssl_split: 'https://images.pexels.com/photos/9875416/pexels-photo-9875416.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940',
  ssl_pju: 'https://images.unsplash.com/photo-1508615070457-7baeba4003ab?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDk1ODB8MHwxfHNlYXJjaHwxfHxzdHJlZXQlMjBsaWdodHxlbnwwfHx8fDE3ODA3MjQ4Mjh8MA&ixlib=rb-4.1.0&q=85',
};

export const heroSlides = [
  {
    id: 1,
    eyebrow: 'ONLINE DOUBLE-CONVERSION UPS',
    title: 'Power your data.',
    subtitle:
      'Perlindungan daya tingkat enterprise untuk server, pusat data, dan infrastruktur kritis Anda. Zero transfer time, 99.9% efisiensi.',
    cta: 'Lihat Produk',
    ctaLink: '/products?category=ups',
    image:
      'https://images.unsplash.com/photo-1580106815433-a5b1d1d53d85?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDQ2MzR8MHwxfHNlYXJjaHwzfHxkYXRhJTIwY2VudGVyfGVufDB8fHx8MTc4MDcyNDgyMXww&ixlib=rb-4.1.0&q=85',
  },
  {
    id: 2,
    eyebrow: 'LINE INTERACTIVE UPS SERIES',
    title: 'Power your office.',
    subtitle:
      'Backup andal untuk PC, workstation, dan peralatan kantor. AVR otomatis, transfer cepat, dan proteksi lonjakan tegangan.',
    cta: 'Jelajahi Seri',
    ctaLink: '/products?category=ups&sub=line-interactive-led',
    image:
      'https://images.unsplash.com/photo-1497366811353-6870744d04b2?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDk1Nzl8MHwxfHNlYXJjaHwxfHxtb2Rlcm4lMjBvZmZpY2V8ZW58MHx8fHwxNzgwNzI0ODM0fDA&ixlib=rb-4.1.0&q=85',
  },
  {
    id: 3,
    eyebrow: 'PURE SINE WAVE INVERTER',
    title: 'Power your home.',
    subtitle:
      'Inverter solar & hybrid dengan output gelombang sinus murni — aman untuk semua peralatan rumah tangga sensitif.',
    cta: 'Pelajari Inverter',
    ctaLink: '/products?category=inverter',
    image:
      'https://images.unsplash.com/photo-1713544123641-5328f51964e4?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA3MDB8MHwxfHNlYXJjaHwxfHxpbnZlcnRlcnxlbnwwfHx8fDE3ODA3MjQ4MjF8MA&ixlib=rb-4.1.0&q=85',
  },
  {
    id: 4,
    eyebrow: 'SOLAR & BATTERY STORAGE',
    title: 'Power your future.',
    subtitle:
      'Panel surya efisiensi tinggi & baterai LiFePO4 modular untuk sistem energi mandiri yang tahan lama.',
    cta: 'Konsultasi Gratis',
    ctaLink: '/contact',
    image:
      'https://images.unsplash.com/photo-1695668548342-c0c1ad479aee?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2Nzh8MHwxfHNlYXJjaHw0fHxzZXJ2ZXIlMjByb29tfGVufDB8fHx8MTc4MDcyNDgyOHww&ixlib=rb-4.1.0&q=85',
  },
];

// ==============================================================
// CATEGORY HIERARCHY
// ==============================================================
export const categoryTree = [
  {
    slug: 'ups',
    title: 'UPS',
    subtitle: 'Uninterruptible Power Supply',
    description:
      'Perlindungan daya dari 600VA hingga 6KVA – line interactive & online double-conversion untuk PC, server, dan infrastruktur kritis.',
    image: IMG.ups_online_3000,
    subcategories: [
      {
        slug: 'line-interactive-led',
        title: 'Line Interactive – LED',
        short: 'Seri ELS – AVR & backup dengan panel LED sederhana',
      },
      {
        slug: 'line-interactive-lcd',
        title: 'Line Interactive – LCD',
        short: 'Seri CLS – kapasitas besar dengan LCD monitoring',
      },
      {
        slug: 'online-lcd',
        title: 'Online UPS – LCD Tower',
        short: 'Seri CLP – double-conversion tower dengan LCD',
      },
      {
        slug: 'online-rack',
        title: 'Online UPS – Rack / Tower',
        short: 'Seri CRP / CT – PF 0.9 untuk data center',
      },
      {
        slug: 'mini-ups',
        title: 'Mini DC UPS',
        short: 'Backup portable untuk router, ONT, & CCTV',
      },
    ],
  },
  {
    slug: 'inverter',
    title: 'Inverter',
    subtitle: 'Power Conversion',
    description:
      'Pure sine wave, hybrid, on-grid & off-grid inverter untuk rumah tinggal, komersial, dan sistem energi terbarukan.',
    image: IMG.inverter_psw,
    subcategories: [
      {
        slug: 'inverter-psw',
        title: 'Eco Type Wave Inverter',
        short: 'Seri CIP – output bersih untuk elektronik sensitif',
      },
      {
        slug: 'inverter-hybrid',
        title: 'Hybrid Inverter',
        short: 'PLN + solar + baterai',
      },
      {
        slug: 'inverter-offgrid',
        title: 'Off-grid Inverter',
        short: 'Sistem mandiri tanpa PLN',
      },
      {
        slug: 'inverter-ongrid',
        title: 'On-grid',
        short: 'Grid-tie, ekspor ke PLN',
      },
    ],
  },
  {
    slug: 'battery',
    title: 'Battery',
    subtitle: 'Energy Storage',
    description:
      'Baterai backup Lead Acid, AGM, dan LiFePO4 dengan opsi rack-mount & standing untuk sistem UPS dan solar.',
    image: IMG.battery_agm,
    subcategories: [
      {
        slug: 'battery-lead-acid',
        title: 'Lead Acid',
        short: 'Konvensional & ekonomis',
      },
      { slug: 'battery-agm', title: 'AGM VRLA', short: 'Maintenance-free' },
      {
        slug: 'battery-lifepo4-rack',
        title: 'LiFePO4 Rack Mount',
        short: '48V modular untuk rack 19"',
      },
      {
        slug: 'battery-lifepo4-standing',
        title: 'LiFePO4 Standing',
        short: 'Cabinet standing berkapasitas besar',
      },
    ],
  },
  {
    slug: 'solar-panel',
    title: 'Solar Panel',
    subtitle: 'Photovoltaic Module',
    description:
      'Panel surya monocrystalline efisiensi tinggi dari 100Wp hingga 600Wp untuk berbagai skala instalasi.',
    image: IMG.solar,
    subcategories: [],
  },
  {
    slug: 'smart-solar-light',
    title: 'Sistem Lampu Tenaga Surya Cerdas',
    subtitle: 'Smart Solar Lighting',
    description:
      'Lampu tenaga surya pintar dengan sensor gerak, timer otomatis, dan remote control – hemat energi untuk jalan, taman, perimeter pabrik, dan area komunitas.',
    image: IMG.ssl_pju,
    subcategories: [
      {
        slug: 'ssl-aio',
        title: 'All-in-One',
        short: 'Panel + baterai + lampu LED terintegrasi',
      },
      {
        slug: 'ssl-split',
        title: 'Split Type',
        short: 'Panel & lampu terpisah, fleksibel',
      },
      {
        slug: 'ssl-pju',
        title: 'PJU Cerdas',
        short: 'Lampu jalan umum tenaga surya',
      },
    ],
  },
];

export const categories = categoryTree.map(({ subcategories, ...c }) => c);

export const findSubcategory = (parentSlug, subSlug) => {
  const parent = categoryTree.find((c) => c.slug === parentSlug);
  return parent?.subcategories.find((s) => s.slug === subSlug);
};

// ==============================================================
// PRODUCTS – full catalog
// price: null → "Minta Penawaran"
// Deskripsi & foto banyak diambil dari i-powerx.com
// ==============================================================
export const products = [
  // ----------- UPS · Line Interactive LED (Seri PX ELS) -----------
  {
    id: 'puof001',
    sku: 'PX 260 ELS',
    name: 'UPS PX 260 ELS 600 VA',
    category: 'ups',
    subcategory: 'line-interactive-led',
    series: 'ELS Line-Interactive Series',
    capacity: '600 VA / 360 W',
    price: null,
    rating: 4.6,
    badge: null,
    short:
      'Line-interactive UPS 600VA dengan multi-layer protection & real-time load monitoring. Ideal untuk PC rumah, modem, dan elektronik penting.',
    image: IMG.ups_led_600,
    specs: {
      Kapasitas: '600 VA / 360 W',
      Topologi: 'Line Interactive',
      Baterai: '12V / 7Ah',
      'Form Factor': 'Compact tower',
      'Dimensi (mm)': '100 × 280 × 142',
      'Berat (kg)': '4.2',
      Aplikasi: 'PC rumah & kantor kecil',
    },
    features: [
      'Backup andal untuk beban esensial',
      'Ringan & mudah dipasang',
      'AVR boost/buck otomatis',
      'Cold start tanpa listrik PLN',
    ],
  },
  {
    id: 'puof002',
    sku: 'PX 280 ELS',
    name: 'UPS PX 280 ELS 800 VA',
    category: 'ups',
    subcategory: 'line-interactive-led',
    series: 'ELS Line-Interactive Series',
    capacity: '800 VA / 480 W',
    price: null,
    rating: 4.6,
    badge: null,
    short:
      'Line-interactive 800VA untuk kombinasi PC + monitor + router dengan runtime lebih panjang.',
    image: IMG.ups_led_800,
    specs: {
      Kapasitas: '800 VA / 480 W',
      Topologi: 'Line Interactive',
      Baterai: '12V / 7Ah',
      'Form Factor': 'Compact tower',
      AVR: 'Boost / Buck',
    },
    features: [
      'AVR boost/buck otomatis',
      'Proteksi RJ45 untuk jaringan',
      'Auto restart setelah PLN normal',
      'Panel LED indikator status',
    ],
  },
  {
    id: 'puof003',
    sku: 'PX 2120 ELS',
    name: 'UPS PX 2120 ELS 1200 VA',
    category: 'ups',
    subcategory: 'line-interactive-led',
    series: 'ELS Line-Interactive Series',
    capacity: '1200 VA / 720 W',
    price: null,
    rating: 4.7,
    badge: 'POPULAR',
    short:
      'Backup andal untuk workstation & POS dengan runtime lebih panjang berkat baterai 24V.',
    image: IMG.ups_led_1200,
    specs: {
      Kapasitas: '1200 VA / 720 W',
      Topologi: 'Line Interactive',
      Baterai: '12V / 8Ah × 2 (24V)',
      'Form Factor': 'Tower',
      AVR: 'Wide-range 140–290 VAC',
    },
    features: [
      'AVR wide-range 140–290 VAC',
      'Cold start mode',
      'Software shutdown otomatis',
      'Panel LED indikator status',
    ],
  },
  {
    id: 'puof004',
    sku: 'PX 2150 ELS',
    name: 'UPS PX 2150 ELS 1500 VA',
    category: 'ups',
    subcategory: 'line-interactive-led',
    series: 'ELS Line-Interactive Series',
    capacity: '1500 VA / 900 W',
    price: null,
    rating: 4.7,
    badge: null,
    short:
      'Line-interactive 1500VA untuk kantor kecil & multi-workstation dengan proteksi surge lengkap.',
    image: IMG.ups_led_1500,
    specs: {
      Kapasitas: '1500 VA / 900 W',
      Topologi: 'Line Interactive',
      Baterai: '12V / 8Ah × 2 (24V)',
      'Form Factor': 'Tower',
      AVR: 'Wide-range',
    },
    features: [
      'AVR wide-range',
      'USB communication port',
      'Overload & short-circuit protection',
      'Cold start',
    ],
  },

  // ----------- UPS · Line Interactive LCD (Seri PX CLS) -----------
  {
    id: 'puof005',
    sku: 'PX 2200 CLS',
    name: 'UPS PX 2200 CLS 2000 VA',
    category: 'ups',
    subcategory: 'line-interactive-lcd',
    series: 'CLS Line-Interactive LCD Series',
    capacity: '2000 VA / 1200 W',
    price: null,
    rating: 4.8,
    badge: 'BEST SELLER',
    short:
      'Line-interactive 2KVA dengan LCD multifungsi & AVR presisi untuk server ringan.',
    image: IMG.ups_lcd_2000,
    specs: {
      Kapasitas: '2000 VA / 1200 W',
      Topologi: 'Line Interactive',
      Baterai: '12V / 9Ah × 2 (24V)',
      Display: 'LCD',
      Komunikasi: 'USB HID (opsional)',
    },
    features: [
      'LCD multifungsi (load, battery, voltage, Hz)',
      'AVR boost/buck presisi',
      'USB HID + software monitoring',
      'Cold start & auto-restart',
    ],
  },
  {
    id: 'puof006',
    sku: 'PX 2300 CLS',
    name: 'UPS PX 2300 CLS 3000 VA',
    category: 'ups',
    subcategory: 'line-interactive-lcd',
    series: 'CLS Line-Interactive LCD Series',
    capacity: '3000 VA / 1800 W',
    price: null,
    rating: 4.8,
    badge: null,
    short:
      'High-capacity line-interactive UPS dengan LCD display, 3000 VA/1800 W – proteksi daya andal untuk sistem esensial.',
    image: IMG.ups_lcd_3000,
    specs: {
      Kapasitas: '3000 VA / 1800 W',
      Topologi: 'Line Interactive',
      Baterai: '12V / 8Ah',
      Display: 'LCD',
      'Dimensi (mm)': '157 × 452 × 211',
      'Berat (kg)': '19.3',
      Komunikasi: 'USB (opsional)',
    },
    features: [
      'Reliable power backup',
      'LCD display untuk monitoring real-time',
      'Cocok untuk critical equipment',
      'Optional USB communication',
    ],
  },

  // ----------- UPS · Online LCD Tower (Seri PX CLP) -----------
  {
    id: 'puon001',
    sku: 'PX 620 CLP',
    name: 'UPS PX 620 CLP 2000 VA (Online)',
    category: 'ups',
    subcategory: 'online-lcd',
    series: 'CLP Online Tower Series',
    capacity: '2000 VA / 1600 W',
    price: null,
    rating: 4.8,
    badge: null,
    short:
      'Advanced line-interactive UPS dengan selectable LCD/LED display, 2000 VA / 1600 W, AVR otomatis & proteksi lengkap.',
    image: IMG.ups_online_2000,
    specs: {
      Kapasitas: '2000 VA / 1600 W',
      Baterai: '12V / 9Ah × 3',
      Display: 'Selectable LED / LCD',
      Kontrol: 'Microprocessor digital',
      'Voltage Regulation': 'Boost & Buck AVR',
      Startup: 'Power-on self test, Cold start',
      Proteksi:
        'Short circuit, overload, surge, overcharge, overdischarge',
      Komunikasi: 'USB & RJ45 (opsional)',
    },
    features: [
      'Microprocessor-based digital control',
      'Boost & buck AVR',
      'Cold start & auto restart',
      'Intelligent battery management',
    ],
  },
  {
    id: 'puon002',
    sku: 'PX 630 CLP',
    name: 'UPS PX 630 CLP 3000 VA (Online)',
    category: 'ups',
    subcategory: 'online-lcd',
    series: 'CLP Online Tower Series',
    capacity: '3000 VA / 2400 W',
    price: null,
    rating: 4.9,
    badge: 'BEST SELLER',
    short:
      'Online UPS 3KVA tower – standar de-facto untuk server rack kelas menengah. Zero transfer time dengan pure sine wave.',
    image: IMG.ups_online_3000,
    specs: {
      Kapasitas: '3000 VA / 2400 W',
      Topologi: 'Online Double-Conversion',
      Baterai: '12V / 9Ah × 4 (48V)',
      Display: 'LCD',
      Output: 'Pure Sine Wave',
      Komunikasi: 'USB / RS232 / SNMP (opsional)',
    },
    features: [
      'Zero transfer time',
      'Pure sine wave output',
      'LCD multifungsi',
      'SNMP slot (opsional)',
    ],
  },

  // ----------- UPS · Online Rack / Tower -----------
  {
    id: 'puon003',
    sku: 'PX 903 CRP',
    name: 'UPS PX 903 CRP 3 KVA Rack',
    category: 'ups',
    subcategory: 'online-rack',
    series: 'CRP Rackmount Online Series',
    capacity: '3 KVA / 2700 W',
    price: null,
    rating: 4.9,
    badge: 'NEW',
    short:
      'Rackmount Dual Conversion UPS 3000 VA / 2700 W – daya bersih tanpa henti untuk sistem kritis. Pure sine wave, zero transfer time, isolasi penuh dari gangguan mains.',
    image: IMG.ups_rack_3k,
    specs: {
      Kapasitas: '3000 VA / 2700 W',
      Topologi: 'Online Double-Conversion',
      'Power Factor': '0.9',
      Baterai: '8 × 12V / 7Ah',
      'Form Factor': 'Rackmount 2U',
      Display: 'LCD professional',
      Aplikasi: 'Server, data center, networking equipment',
    },
    features: [
      'Output PF 0.9',
      'Rack 2U / Tower convertible',
      'Battery temperature compensation & three-stage charging',
      'LCD display untuk monitoring beban',
    ],
  },
  {
    id: 'puon004',
    sku: 'PX 806 CT',
    name: 'UPS PX 806 CT 6 KVA Tower',
    category: 'ups',
    subcategory: 'online-rack',
    series: 'CT Tower Online Series',
    capacity: '6 KVA / 4800 W',
    price: null,
    rating: 4.9,
    badge: 'ENTERPRISE',
    short:
      'Powerful Dual Conversion UPS tower 6000 VA / 4800 W dengan pure sine wave, full-time voltage regulation & FX UPS Guard technology untuk data center dan industri.',
    image: IMG.ups_tower_6k,
    specs: {
      Kapasitas: '6000 VA / 4800 W',
      Topologi: 'Online Double-Conversion',
      Baterai: '16 × 12V / 9Ah',
      'Form Factor': 'Tower',
      Display: 'LCD real-time status',
      'Protection Technology': 'FX UPS Guard & Power Well',
      Aplikasi: 'Data center, industrial equipment',
    },
    features: [
      'Pure sine wave output',
      'FX UPS Guard & Power Well protection',
      'LCD monitoring canggih',
      'Zero transfer time',
    ],
  },

  // ----------- UPS · Mini DC UPS -----------
  {
    id: 'pmun001',
    sku: 'EPW 103',
    name: 'MINI DC UPS – EPW 103',
    category: 'ups',
    subcategory: 'mini-ups',
    series: 'EPW Portable Series',
    capacity: '10,400 mAh · USB 5V + DC 9V/12V',
    price: null,
    rating: 4.7,
    badge: 'NEW',
    short:
      'Portable multi-output DC mini UPS dengan output USB 5V 2A, DC 9V 1A & DC 12V 1A. Zero transfer time untuk router, ONT, CCTV & network device.',
    image: IMG.mini_ups_epw,
    specs: {
      'Output Ports':
        'USB 5V 2A + DC 9V 1A + DC 12V 1A (konfigurasi 9V+9V / 12V+12V / 9V+12V)',
      Input: 'Type-C',
      'Transfer Time': 'Zero',
      'Battery Capacity': '±10,400 mAh (18650 cells)',
      'Backup Duration': '> 8 jam (tergantung beban)',
      Proteksi: 'Over-charge, over-discharge, short-circuit',
      Aplikasi: 'Router, ONT/ONU, CCTV, smartphone (USB)',
    },
    features: [
      'Multi-voltage output (USB + DC 9V + DC 12V)',
      'Zero transfer time saat listrik padam',
      'Grade-A 18650 battery cells',
      'Support Type-C input',
    ],
  },
  {
    id: 'pmun002',
    sku: 'UPS 505',
    name: 'MINI DC UPS – UPS 505',
    category: 'ups',
    subcategory: 'mini-ups',
    series: 'UPS 505 Portable Series',
    capacity: 'DC Multi-output',
    price: null,
    rating: 4.7,
    badge: null,
    short:
      'Mini DC UPS portable dengan multi output untuk router & perangkat DC – kompak dan siap plug & play.',
    image: IMG.mini_ups_505,
    specs: {
      'Output Ports': 'USB 5V + DC 9V / 12V',
      'Transfer Time': 'Zero',
      'Battery Cells': '18650',
      Proteksi: 'Over-charge, over-discharge, short-circuit',
      Aplikasi: 'Router, ONT, network device',
    },
    features: [
      'Portable & ringan',
      'Zero transfer time',
      'Multi output DC',
      'Cocok untuk WFH / home network',
    ],
  },

  // ----------- Battery · Lead Acid -----------
  {
    id: 'pbla001',
    sku: 'PX 12-38 LA',
    name: 'Battery PX 12-38 LA 12V 38Ah',
    category: 'battery',
    subcategory: 'battery-lead-acid',
    series: 'PX Lead-Acid Series',
    capacity: '12V / 38Ah',
    price: null,
    rating: 4.5,
    badge: null,
    short:
      'Baterai lead-acid 12V 38Ah untuk UPS & backup ringan – harga ekonomis dengan cycle life stabil.',
    image: IMG.battery_lead,
    specs: {
      Tipe: 'Sealed Lead Acid',
      Tegangan: '12 V',
      Kapasitas: '38 Ah',
      Terminal: 'F13',
      Aplikasi: 'UPS / backup',
    },
    features: [
      'Harga ekonomis',
      'Cocok untuk UPS ≤ 3KVA',
      'Dimensi standar industri',
      'Cycle life stabil pada beban ringan',
    ],
  },
  {
    id: 'pbla002',
    sku: 'PX 12-65 LA',
    name: 'Battery PX 12-65 LA 12V 65Ah',
    category: 'battery',
    subcategory: 'battery-lead-acid',
    series: 'PX Lead-Acid Series',
    capacity: '12V / 65Ah',
    price: null,
    rating: 4.5,
    badge: null,
    short:
      'Kapasitas 65Ah untuk runtime UPS lebih panjang – kompatibel dengan external battery pack.',
    image: IMG.battery_lead,
    specs: {
      Tipe: 'Sealed Lead Acid',
      Tegangan: '12 V',
      Kapasitas: '65 Ah',
      Terminal: 'F13',
      Aplikasi: 'UPS / backup',
    },
    features: [
      'Runtime lebih panjang',
      'Kompatibel dengan external battery pack',
      'Dimensi standar industri',
      'Rated 5-year service life',
    ],
  },

  // ----------- Battery · AGM VRLA -----------
  {
    id: 'pbag001',
    sku: 'PX 100-12 LA',
    name: 'Battery PX 100-12 LA AGM 12V 100Ah',
    category: 'battery',
    subcategory: 'battery-agm',
    series: 'PX AGM VRLA Series',
    capacity: '12V / 100Ah',
    price: null,
    rating: 4.8,
    badge: 'BEST SELLER',
    short:
      'Premium 12V 100Ah AGM VRLA battery – engineered for long life, high performance, dan reliability untuk mission-critical systems.',
    image: IMG.battery_agm,
    specs: {
      Tipe: 'AGM VRLA',
      Tegangan: '12 V',
      Kapasitas: '100 Ah',
      Teknologi: 'Premium AGM Deep Cycle',
      Aplikasi: 'Solar / UPS / Telecom',
      Sifat: 'Maintenance-free',
    },
    features: [
      'Premium AGM VRLA technology',
      'Kapasitas tinggi & runtime panjang',
      'Maintenance-free & bebas gas',
      'Cocok untuk mission-critical systems',
    ],
  },

  // ----------- Battery · LiFePO4 Rack Mount -----------
  {
    id: 'pblr001',
    sku: 'PBLR001',
    name: 'Battery LiFePO4 Rack Mount 51.2V 100Ah',
    category: 'battery',
    subcategory: 'battery-lifepo4-rack',
    series: 'LiFePO4 Rack Series',
    capacity: '51.2V / 100Ah · 5.12 kWh',
    price: null,
    rating: 4.9,
    badge: 'NEW',
    short:
      'Modul lithium 5kWh rack 19" – siap paralel untuk skala energi rumah tangga.',
    image: IMG.battery_lifepo4,
    specs: {
      Tipe: 'LiFePO4',
      Tegangan: '51.2 V',
      Kapasitas: '100 Ah',
      Energi: '5.12 kWh',
      Konfigurasi: 'Rack Mount 19"',
      Komunikasi: 'RS485 / CAN',
    },
    features: [
      'BMS terintegrasi dengan proteksi lengkap',
      'Paralel hingga 16 modul',
      'Cycle life > 6000 siklus',
      'Kompatibel inverter hybrid utama',
    ],
  },
  {
    id: 'pblr002',
    sku: 'PBLR002',
    name: 'Battery LiFePO4 Rack Mount 51.2V 200Ah',
    category: 'battery',
    subcategory: 'battery-lifepo4-rack',
    series: 'LiFePO4 Rack Series',
    capacity: '51.2V / 200Ah · 10.24 kWh',
    price: null,
    rating: 4.9,
    badge: null,
    short: 'Modul 10kWh rack – ideal untuk backup skala komersial ringan.',
    image: IMG.battery_lifepo4,
    specs: {
      Tipe: 'LiFePO4',
      Tegangan: '51.2 V',
      Kapasitas: '200 Ah',
      Energi: '10.24 kWh',
      Konfigurasi: 'Rack Mount',
      Komunikasi: 'RS485 / CAN',
    },
    features: [
      'BMS canggih dengan cell balancing',
      'Paralel-ready',
      'IP20 – siap indoor rack',
      'Warranty 10 tahun',
    ],
  },
  {
    id: 'pblr003',
    sku: 'PBLR003',
    name: 'Battery LiFePO4 Rack Mount 51.2V 300Ah',
    category: 'battery',
    subcategory: 'battery-lifepo4-rack',
    series: 'LiFePO4 Rack Series',
    capacity: '51.2V / 300Ah · 15.36 kWh',
    price: null,
    rating: 5.0,
    badge: 'ENTERPRISE',
    short: 'Modul 15kWh rack untuk sistem energi mandiri skala besar.',
    image: IMG.battery_lifepo4,
    specs: {
      Tipe: 'LiFePO4',
      Tegangan: '51.2 V',
      Kapasitas: '300 Ah',
      Energi: '15.36 kWh',
      Konfigurasi: 'Rack Mount',
      Komunikasi: 'RS485 / CAN',
    },
    features: [
      'Cycle life > 6000',
      'Modular scalable',
      'BMS smart balancing',
      'Warranty 10 tahun',
    ],
  },

  // ----------- Battery · LiFePO4 Standing -----------
  {
    id: 'pbls001',
    sku: 'PBLS001',
    name: 'Battery LiFePO4 Standing 51.2V 100Ah',
    category: 'battery',
    subcategory: 'battery-lifepo4-standing',
    series: 'LiFePO4 Standing Series',
    capacity: '51.2V / 100Ah · 5.12 kWh',
    price: null,
    rating: 4.8,
    badge: null,
    short:
      'Cabinet standing 5kWh dengan roda – siap plug & play tanpa rack.',
    image: IMG.battery_lifepo4,
    specs: {
      Tipe: 'LiFePO4',
      Tegangan: '51.2 V',
      Kapasitas: '100 Ah',
      Energi: '5.12 kWh',
      Konfigurasi: 'Standing Cabinet',
    },
    features: [
      'Plug & play installation',
      'BMS terintegrasi',
      'Standing cabinet dengan roda',
      'Cycle life > 6000',
    ],
  },
  {
    id: 'pbls002',
    sku: 'PBLS002',
    name: 'Battery LiFePO4 Standing 51.2V 200Ah',
    category: 'battery',
    subcategory: 'battery-lifepo4-standing',
    series: 'LiFePO4 Standing Series',
    capacity: '51.2V / 200Ah · 10.24 kWh',
    price: null,
    rating: 4.8,
    badge: null,
    short: 'Standing 10kWh untuk rumah tinggal & UMKM.',
    image: IMG.battery_lifepo4,
    specs: {
      Tipe: 'LiFePO4',
      Tegangan: '51.2 V',
      Kapasitas: '200 Ah',
      Energi: '10.24 kWh',
      Konfigurasi: 'Standing Cabinet',
    },
    features: [
      'BMS smart balancing',
      'Standing cabinet',
      'Paralel-ready',
      'Warranty 10 tahun',
    ],
  },

  // ----------- Inverter · Pure Sine Wave (Seri PX CIP) -----------
  {
    id: 'piup001',
    sku: 'PX 6012 CIP',
    name: 'Inverter UPS PX 6012 CIP 600 W',
    category: 'inverter',
    subcategory: 'inverter-psw',
    series: 'CIP Pure Sine Wave Series',
    capacity: '600 W / 12V',
    price: null,
    rating: 4.7,
    badge: null,
    short:
      'Professional-grade inverter UPS dengan 600W pure sine wave output – ideal untuk elektronik sensitif. Voltage stabilization, multi-protection, dan LCD interface yang jelas.',
    image: IMG.inverter_psw,
    specs: {
      Kapasitas: '600 W',
      Baterai: '12 V',
      'Output Waveform': 'Pure Sine Wave',
      Kontrol: 'DSP digital control',
      'Charge Current': 'Max 60 A (adjustable, default 20 A)',
      Efisiensi: 'Max 95% (mains), 80% (inverter)',
      Proteksi:
        'Short circuit, overload, overcharge, undervoltage, overtemperature',
      Modes: 'No-load shutdown, ECO mode',
      'Optional Modules': 'MPPT (solar), DC module',
    },
    features: [
      'Pure sine wave & DSP control',
      'Intelligent adjustable charging (up to 60A)',
      'LCD & buzzer interface',
      'Optional MPPT untuk off-grid solar',
    ],
  },
  {
    id: 'piup002',
    sku: 'PX 1012 CIP',
    name: 'Inverter UPS PX 1012 CIP 1000 W',
    category: 'inverter',
    subcategory: 'inverter-psw',
    series: 'CIP Pure Sine Wave Series',
    capacity: '1000 W / 12V',
    price: null,
    rating: 4.7,
    badge: 'POPULAR',
    short:
      'Inverter/UPS PSW 1000W dengan DSP control – solusi backup rumah dengan output bersih.',
    image: IMG.inverter_psw_alt,
    specs: {
      Kapasitas: '1000 W',
      Baterai: '12 V',
      'Output Waveform': 'Pure Sine Wave',
      Kontrol: 'DSP digital',
      Display: 'LCD',
      Modes: 'ECO, no-load shutdown',
    },
    features: [
      'Pure sine wave output',
      'LCD multifungsi',
      'Intelligent charging',
      'Cold start & auto restart',
    ],
  },

  // ----------- Inverter · Hybrid -----------
  {
    id: 'pihb001',
    sku: 'PIHB001',
    name: 'Inverter Hybrid 3KVA',
    category: 'inverter',
    subcategory: 'inverter-hybrid',
    series: 'PowerX Hybrid Series',
    capacity: '3 KVA / 24V',
    price: null,
    rating: 4.7,
    badge: 'SOLAR READY',
    short:
      'Hybrid 3KVA dengan MPPT built-in – ideal untuk rumah tinggal starter.',
    image: IMG.inverter_hybrid,
    specs: {
      Tipe: 'Hybrid Inverter',
      Kapasitas: '3 KVA',
      'DC Voltage': '24 V',
      MPPT: 'Terintegrasi',
      Output: 'Pure Sine Wave',
    },
    features: [
      'MPPT solar controller terintegrasi',
      'Auto switch PLN ↔ Solar ↔ Baterai',
      'Monitoring WiFi',
      'Parallel-ready',
    ],
  },
  {
    id: 'pihb002',
    sku: 'PIHB002',
    name: 'Inverter Hybrid 5KVA',
    category: 'inverter',
    subcategory: 'inverter-hybrid',
    series: 'PowerX Hybrid Series',
    capacity: '5 KVA / 48V',
    price: null,
    rating: 4.9,
    badge: 'BEST SELLER',
    short:
      'Hybrid 5KVA – standar untuk rumah lengkap dengan PV array besar.',
    image: IMG.inverter_hybrid,
    specs: {
      Tipe: 'Hybrid Inverter',
      Kapasitas: '5 KVA',
      'DC Voltage': '48 V',
      MPPT: 'Dual MPPT',
      Output: 'Pure Sine Wave',
    },
    features: [
      'Dual MPPT input',
      'Kompatibel baterai Li & Lead-Acid',
      'Parallel hingga 6 unit',
      'Garansi 5 tahun',
    ],
  },
  {
    id: 'pihb003',
    sku: 'PIHB003',
    name: 'Inverter Hybrid 6KVA',
    category: 'inverter',
    subcategory: 'inverter-hybrid',
    series: 'PowerX Hybrid Series',
    capacity: '6 KVA / 48V',
    price: null,
    rating: 4.8,
    badge: null,
    short: 'Hybrid 6KVA untuk rumah besar & UMKM.',
    image: IMG.inverter_hybrid,
    specs: {
      Tipe: 'Hybrid Inverter',
      Kapasitas: '6 KVA',
      'DC Voltage': '48 V',
      MPPT: 'Dual MPPT',
      Output: 'Pure Sine Wave',
    },
    features: [
      'Dual MPPT input',
      'Parallel-ready',
      'Smart grid feed-in (opsional)',
      'Garansi 5 tahun',
    ],
  },
  {
    id: 'pihb004',
    sku: 'PIHB004',
    name: 'Inverter Hybrid 10KVA',
    category: 'inverter',
    subcategory: 'inverter-hybrid',
    series: 'PowerX Hybrid Series',
    capacity: '10 KVA / 48V',
    price: null,
    rating: 4.9,
    badge: 'ENTERPRISE',
    short: 'Hybrid 10KVA 3-phase – solusi komersial & industri kecil.',
    image: IMG.inverter_hybrid,
    specs: {
      Tipe: 'Hybrid Inverter',
      Kapasitas: '10 KVA',
      'DC Voltage': '48 V',
      MPPT: 'Dual MPPT',
      Output: 'Pure Sine Wave',
    },
    features: [
      'Dual MPPT input',
      'Parallel hingga 10 unit',
      'Grid feed-in support',
      'On-site commissioning',
    ],
  },

  // ----------- Inverter · Off-grid -----------
  {
    id: 'piof001',
    sku: 'PIOF001',
    name: 'Inverter Off-grid 3KVA',
    category: 'inverter',
    subcategory: 'inverter-offgrid',
    series: 'PowerX Off-grid Series',
    capacity: '3 KVA',
    price: null,
    rating: 4.7,
    badge: null,
    short: 'Off-grid 3KVA untuk sistem mandiri di area tanpa PLN.',
    image: IMG.inverter_off,
    specs: {
      Tipe: 'Off-grid Inverter',
      Kapasitas: '3 KVA',
      Output: 'Pure Sine Wave',
    },
    features: [
      'Cocok untuk sistem PV mandiri',
      'MPPT solar charger',
      'Baterai LiFePO4 / Lead-Acid',
      'LCD monitoring',
    ],
  },
  {
    id: 'piof002',
    sku: 'PIOF002',
    name: 'Inverter Off-grid 5KVA',
    category: 'inverter',
    subcategory: 'inverter-offgrid',
    series: 'PowerX Off-grid Series',
    capacity: '5 KVA',
    price: null,
    rating: 4.8,
    badge: null,
    short: 'Off-grid 5KVA – standar rumah remote area.',
    image: IMG.inverter_off,
    specs: {
      Tipe: 'Off-grid Inverter',
      Kapasitas: '5 KVA',
      Output: 'Pure Sine Wave',
    },
    features: [
      'MPPT solar charger',
      'Baterai LiFePO4 / Lead-Acid',
      'LCD monitoring',
      'Parallel-ready',
    ],
  },
  {
    id: 'piof003',
    sku: 'PIOF003',
    name: 'Inverter Off-grid 6KVA',
    category: 'inverter',
    subcategory: 'inverter-offgrid',
    series: 'PowerX Off-grid Series',
    capacity: '6 KVA',
    price: null,
    rating: 4.8,
    badge: null,
    short: 'Off-grid 6KVA untuk fasilitas komunitas & fasilitas remote.',
    image: IMG.inverter_off,
    specs: {
      Tipe: 'Off-grid Inverter',
      Kapasitas: '6 KVA',
      Output: 'Pure Sine Wave',
    },
    features: [
      'MPPT solar charger',
      'Parallel-ready',
      'LCD monitoring',
      'Support baterai Li & Lead-Acid',
    ],
  },
  {
    id: 'pion001',
    sku: 'PION001',
    name: 'Inverter Off-grid 10KVA',
    category: 'inverter',
    subcategory: 'inverter-offgrid',
    series: 'PowerX Off-grid Series',
    capacity: '10 KVA',
    price: null,
    rating: 4.9,
    badge: 'ENTERPRISE',
    short: 'Off-grid 10KVA untuk villa & fasilitas komersial di remote area.',
    image: IMG.inverter_off,
    specs: {
      Tipe: 'Off-grid Inverter',
      Kapasitas: '10 KVA',
      Output: 'Pure Sine Wave',
    },
    features: [
      'Dual MPPT',
      'Parallel hingga 10 unit',
      'LCD monitoring canggih',
      'Support LiFePO4 rack modular',
    ],
  },

  // ----------- Inverter · On-grid -----------
  {
    id: 'pion002',
    sku: 'PION002',
    name: 'Inverter On-grid 3KVA',
    category: 'inverter',
    subcategory: 'inverter-ongrid',
    series: 'PowerX On-grid Series',
    capacity: '3 KVA',
    price: null,
    rating: 4.7,
    badge: null,
    short: 'Grid-tie 3KVA untuk PLTS atap rumah tinggal.',
    image: IMG.inverter_on,
    specs: {
      Tipe: 'On-grid Inverter',
      Kapasitas: '3 KVA',
      Output: 'Pure Sine Wave',
    },
    features: [
      'Grid-tie compliant',
      'Anti-islanding protection',
      'WiFi monitoring',
      'IP65 outdoor',
    ],
  },
  {
    id: 'pion003',
    sku: 'PION003',
    name: 'Inverter On-grid 5KVA',
    category: 'inverter',
    subcategory: 'inverter-ongrid',
    series: 'PowerX On-grid Series',
    capacity: '5 KVA',
    price: null,
    rating: 4.8,
    badge: null,
    short: 'Grid-tie 5KVA untuk PLTS atap rumah menengah.',
    image: IMG.inverter_on,
    specs: {
      Tipe: 'On-grid Inverter',
      Kapasitas: '5 KVA',
      Output: 'Pure Sine Wave',
    },
    features: [
      'Grid-tie compliant',
      'Anti-islanding',
      'WiFi + RS485 monitoring',
      'IP65 outdoor',
    ],
  },

  // ----------- Solar Panel -----------
  {
    id: 'pspm001',
    sku: 'PSPM001',
    name: 'Solar Panel 100 Wp',
    category: 'solar-panel',
    subcategory: null,
    series: 'PowerX Mono Series',
    capacity: '100 Wp',
    price: null,
    rating: 4.6,
    badge: null,
    short: 'Panel monocrystalline 100Wp untuk aplikasi portable & DIY.',
    image: IMG.solar,
    specs: {
      Tipe: 'Monocrystalline',
      'Peak Power': '100 Wp',
      'Vmp / Imp': '18 V / 5.55 A',
      Aplikasi: 'Portable / Off-grid',
    },
    features: [
      'Efisiensi tinggi > 20%',
      'Frame aluminium anodized',
      'Kaca tempered anti-refleksi',
      'Warranty performa 25 tahun',
    ],
  },
  {
    id: 'pspm002',
    sku: 'PSPM002',
    name: 'Solar Panel 150 Wp',
    category: 'solar-panel',
    subcategory: null,
    series: 'PowerX Mono Series',
    capacity: '150 Wp',
    price: null,
    rating: 4.6,
    badge: null,
    short: 'Panel 150Wp untuk sistem off-grid dan mobile.',
    image: IMG.solar,
    specs: {
      Tipe: 'Monocrystalline',
      'Peak Power': '150 Wp',
      Aplikasi: 'Off-grid',
    },
    features: [
      'Frame aluminium anodized',
      'Kaca tempered',
      'Junction box IP67',
      'Warranty performa 25 tahun',
    ],
  },
  {
    id: 'pspm003',
    sku: 'PSPM003',
    name: 'Solar Panel 200 Wp',
    category: 'solar-panel',
    subcategory: null,
    series: 'PowerX Mono Series',
    capacity: '200 Wp',
    price: null,
    rating: 4.6,
    badge: null,
    short: 'Panel 200Wp untuk instalasi rumah tinggal skala kecil.',
    image: IMG.solar,
    specs: {
      Tipe: 'Monocrystalline',
      'Peak Power': '200 Wp',
      Aplikasi: 'Residential',
    },
    features: [
      'Half-cut cell technology',
      'PID resistant',
      'Junction box IP67',
      'Warranty performa 25 tahun',
    ],
  },
  {
    id: 'pspm004',
    sku: 'PSPM004',
    name: 'Solar Panel 450 Wp',
    category: 'solar-panel',
    subcategory: null,
    series: 'PowerX Mono Series',
    capacity: '450 Wp',
    price: null,
    rating: 4.8,
    badge: 'POPULAR',
    short: 'Panel 450Wp – standar untuk PLTS atap rumah tinggal.',
    image: IMG.solar_alt,
    specs: {
      Tipe: 'Monocrystalline Half-Cut',
      'Peak Power': '450 Wp',
      Aplikasi: 'Residential / Commercial',
    },
    features: [
      'Half-cut cell efficiency',
      'PID resistant',
      'Frame reinforced 35 mm',
      'Warranty performa 25 tahun',
    ],
  },
  {
    id: 'pspm005',
    sku: 'PSPM005',
    name: 'Solar Panel 550 Wp',
    category: 'solar-panel',
    subcategory: null,
    series: 'PowerX Mono Series',
    capacity: '550 Wp',
    price: null,
    rating: 4.8,
    badge: null,
    short: 'Panel 550Wp untuk PLTS komersial & industri.',
    image: IMG.solar_alt,
    specs: {
      Tipe: 'Monocrystalline Half-Cut',
      'Peak Power': '550 Wp',
      Aplikasi: 'Commercial / Industrial',
    },
    features: [
      'Half-cut cell efficiency',
      'PID resistant',
      'Anti-PID + LID',
      'Warranty performa 25 tahun',
    ],
  },
  {
    id: 'pspm006',
    sku: 'PSPM006',
    name: 'Solar Panel 600 Wp',
    category: 'solar-panel',
    subcategory: null,
    series: 'PowerX Mono Series',
    capacity: '600 Wp',
    price: null,
    rating: 4.9,
    badge: 'NEW',
    short: 'Panel 600Wp N-type Bifacial – performa tertinggi di kelasnya.',
    image: IMG.solar_alt,
    specs: {
      Tipe: 'Monocrystalline N-type Bifacial',
      'Peak Power': '600 Wp',
      Aplikasi: 'Utility / Commercial',
    },
    features: [
      'Bifacial – gain hingga 25%',
      'N-type efisiensi > 22%',
      'Low degradation < 1% tahun 1',
      'Warranty performa 30 tahun',
    ],
  },

  // ----------- Smart Solar Lighting · All-in-One -----------
  {
    id: 'pssl001',
    sku: 'PSSL-AIO-30',
    name: 'Smart Solar Light All-in-One 30 W',
    category: 'smart-solar-light',
    subcategory: 'ssl-aio',
    series: 'PowerX Smart Solar Series',
    capacity: '30 W · 3000 lm',
    price: null,
    rating: 4.7,
    badge: null,
    short:
      'Lampu tenaga surya all-in-one 30W dengan sensor PIR & timer – panel, baterai LiFePO4, dan LED terintegrasi dalam satu unit.',
    image: IMG.ssl_aio,
    specs: {
      'Lumen Output': '3000 lm',
      'LED Power': '30 W',
      'Solar Panel': '40 Wp Monocrystalline',
      Battery: 'LiFePO4 12.8V / 15Ah',
      Sensor: 'PIR + Light Sensor',
      Mode: 'Auto Dim / Timer / Remote',
      'IP Rating': 'IP65',
      Aplikasi: 'Taman, gang, perimeter rumah',
    },
    features: [
      'All-in-one – panel, baterai, LED terintegrasi',
      'Sensor gerak PIR & timer otomatis',
      'Remote control jarak jauh',
      'IP65 tahan hujan & debu',
    ],
  },
  {
    id: 'pssl002',
    sku: 'PSSL-AIO-60',
    name: 'Smart Solar Light All-in-One 60 W',
    category: 'smart-solar-light',
    subcategory: 'ssl-aio',
    series: 'PowerX Smart Solar Series',
    capacity: '60 W · 6000 lm',
    price: null,
    rating: 4.8,
    badge: 'POPULAR',
    short:
      'All-in-one 60W untuk penerangan area lebih luas – kompleks perumahan, area parkir, & fasilitas komunitas.',
    image: IMG.ssl_aio,
    specs: {
      'Lumen Output': '6000 lm',
      'LED Power': '60 W',
      'Solar Panel': '80 Wp Monocrystalline',
      Battery: 'LiFePO4 12.8V / 30Ah',
      Sensor: 'PIR + Light Sensor',
      Mode: 'Auto Dim / Timer / Remote',
      'IP Rating': 'IP65',
      Aplikasi: 'Kompleks perumahan, area parkir',
    },
    features: [
      'Iluminasi 6000 lm untuk area luas',
      'Sensor gerak PIR & light sensor',
      'Baterai LiFePO4 cycle life > 3000',
      'Remote control + timer',
    ],
  },
  {
    id: 'pssl003',
    sku: 'PSSL-AIO-100',
    name: 'Smart Solar Light All-in-One 100 W',
    category: 'smart-solar-light',
    subcategory: 'ssl-aio',
    series: 'PowerX Smart Solar Series',
    capacity: '100 W · 10.000 lm',
    price: null,
    rating: 4.8,
    badge: null,
    short:
      'All-in-one 100W untuk penerangan intens – jalan komplek industri & area komersial.',
    image: IMG.ssl_aio,
    specs: {
      'Lumen Output': '10.000 lm',
      'LED Power': '100 W',
      'Solar Panel': '120 Wp Monocrystalline',
      Battery: 'LiFePO4 12.8V / 45Ah',
      Sensor: 'PIR + Light Sensor',
      Mode: 'Auto Dim / Timer / Remote',
      'IP Rating': 'IP66',
    },
    features: [
      'Iluminasi 10.000 lm',
      'IP66 tahan cuaca ekstrim',
      'Sensor PIR & light sensor',
      'Backup 3 malam tanpa matahari',
    ],
  },

  // ----------- Smart Solar Lighting · Split Type -----------
  {
    id: 'pssl004',
    sku: 'PSSL-SP-150',
    name: 'Smart Solar Light Split Type 150 W',
    category: 'smart-solar-light',
    subcategory: 'ssl-split',
    series: 'PowerX Smart Solar Split',
    capacity: '150 W · 15.000 lm',
    price: null,
    rating: 4.8,
    badge: 'NEW',
    short:
      'Split type 150W – panel surya terpisah untuk fleksibilitas orientasi. Ideal untuk area dengan bayangan pohon.',
    image: IMG.ssl_split,
    specs: {
      'Lumen Output': '15.000 lm',
      'LED Power': '150 W',
      'Solar Panel': '200 Wp (terpisah, kabel 5m)',
      Battery: 'LiFePO4 25.6V / 40Ah',
      Sensor: 'PIR + Microwave',
      Mode: 'Auto / Timer / App Control',
      'IP Rating': 'IP66',
    },
    features: [
      'Panel terpisah, fleksibel arah panel',
      'Baterai LiFePO4 kapasitas besar',
      'App control via WiFi',
      'Sensor PIR + Microwave (deteksi 12m)',
    ],
  },

  // ----------- Smart Solar Lighting · PJU (Jalan Umum) -----------
  {
    id: 'pssl005',
    sku: 'PSSL-PJU-100',
    name: 'PJU Cerdas 100 W (Lampu Jalan Tenaga Surya)',
    category: 'smart-solar-light',
    subcategory: 'ssl-pju',
    series: 'PowerX PJU Series',
    capacity: '100 W · 12.000 lm',
    price: null,
    rating: 4.9,
    badge: 'POPULAR',
    short:
      'Lampu PJU tenaga surya 100W untuk jalan lingkungan – standar SNI dengan proteksi surge & monitoring GSM.',
    image: IMG.ssl_pju,
    specs: {
      'Lumen Output': '12.000 lm',
      'LED Power': '100 W',
      'Solar Panel': '150 Wp',
      Battery: 'LiFePO4 12.8V / 50Ah',
      Kontroler: 'MPPT + Timer + Dimming',
      'Tinggi Tiang': '7-9 meter',
      'IP Rating': 'IP67',
      Sertifikasi: 'SNI, TKDN',
    },
    features: [
      'Standar SNI untuk PJU',
      'MPPT charge controller',
      'Sistem dimming otomatis (100%→50%)',
      'Monitoring GSM (opsional)',
    ],
  },
  {
    id: 'pssl006',
    sku: 'PSSL-PJU-200',
    name: 'PJU Cerdas 200 W (Lampu Jalan Tenaga Surya)',
    category: 'smart-solar-light',
    subcategory: 'ssl-pju',
    series: 'PowerX PJU Series',
    capacity: '200 W · 24.000 lm',
    price: null,
    rating: 4.9,
    badge: 'ENTERPRISE',
    short:
      'PJU 200W untuk jalan arteri & jalan kabupaten – iluminasi tinggi dengan tiang 9-12m.',
    image: IMG.ssl_pju,
    specs: {
      'Lumen Output': '24.000 lm',
      'LED Power': '200 W',
      'Solar Panel': '300 Wp',
      Battery: 'LiFePO4 25.6V / 60Ah',
      Kontroler: 'MPPT + IoT Monitoring',
      'Tinggi Tiang': '9-12 meter',
      'IP Rating': 'IP67',
      Sertifikasi: 'SNI, TKDN',
    },
    features: [
      'Iluminasi 24.000 lm untuk jalan arteri',
      'IoT monitoring & remote management',
      'MPPT + battery temperature compensation',
      'Backup 3-5 malam autonomy',
    ],
  },
];

export const stats = [
  { value: '120+', label: 'Mitra Distributor' },
  { value: '24/7', label: 'Dukungan Teknis' },
];

export const features = [
  {
    icon: 'ShieldCheck',
    title: 'Proteksi Total',
    desc: 'Filter EMI/RFI, surge protection, dan stabilisasi tegangan otomatis di setiap unit.',
  },
  {
    icon: 'Zap',
    title: 'Zero Transfer Time',
    desc: 'Seri Online kami menjaga peralatan tetap menyala tanpa jeda saat PLN mati.',
  },
  {
    icon: 'Cpu',
    title: 'Smart Monitoring',
    desc: 'Pantau status UPS Anda dari mana saja melalui aplikasi mobile & dashboard web.',
  },
  {
    icon: 'Leaf',
    title: 'Efisien & Hijau',
    desc: 'Mode ECO hingga efisiensi 98.5% — hemat listrik & ramah lingkungan.',
  },
  {
    icon: 'Wrench',
    title: 'Mudah Dirawat',
    desc: 'Desain modular dengan hot-swap battery untuk maintenance tanpa downtime.',
  },
  {
    icon: 'Headphones',
    title: 'Dukungan Lokal',
    desc: 'Tim engineer di 18+ kota Indonesia siap membantu kapanpun dibutuhkan.',
  },
];

// -------------------- NEWS & ARTIKEL --------------------
// Konten edukasi untuk calon pelanggan. 2 pertama = infografis dari user,
// 5 lainnya artikel pendukung. Setiap artikel punya `slug`, `tag`, `title`,
// `excerpt`, `image` (cover), `author`, `date`, `read`, `category`, `body`
// (array of blocks: {type:'p'|'h2'|'ul'|'image'|'quote'|'cta', ...})

export const articleCategories = [
  { slug: 'all', title: 'Semua' },
  { slug: 'panduan', title: 'Panduan' },
  { slug: 'edukasi', title: 'Edukasi' },
  { slug: 'produk', title: 'Produk' },
  { slug: 'studi-kasus', title: 'Studi Kasus' },
];

export const articles = [
  {
    slug: 'contoh-aplikasi-solar-tanpa-baterai-1300-watt',
    tag: 'CONTOH APLIKASI',
    category: 'contoh-aplikasi',
    tab: 'contoh-aplikasi',
    group: 'solar-panel',
    featured: false,
    title: 'Contoh Aplikasi: Sistem Solar Panel Tanpa Baterai untuk Kebutuhan 1.300 Watt',
    excerpt:
      'Skema grid-tie (on-grid) tanpa baterai: 8 panel 600 Wp + inverter PXH6.6K-1PLVG1 langsung memangkas penggunaan listrik PLN di siang hari — estimasi hemat ±720 kWh per bulan.',
    image: 'https://customer-assets-eiarnc6j.emergentagent.net/job_ed34ddae-2acd-408a-97ce-e44390688f17/artifacts/vn3ek2ec_3.Battery-Free%20Solar%20Panel%20System%20Infographic%20tanpa%20baterai.png',
    author: 'Tim PowerX',
    date: '2026-10-02',
    read: '6 menit',
    body: [
      { type: 'p', text: 'Tidak semua sistem solar panel butuh baterai. Untuk rumah dan kantor dengan penggunaan listrik dominan di siang hari, sistem grid-tie (on-grid) tanpa baterai adalah pilihan paling ekonomis — energi matahari langsung mengurangi pemakaian listrik PLN. Infografis berikut merinci skema lengkapnya untuk beban 1.300 Watt.' },
      { type: 'image', src: 'https://customer-assets-eiarnc6j.emergentagent.net/job_ed34ddae-2acd-408a-97ce-e44390688f17/artifacts/vn3ek2ec_3.Battery-Free%20Solar%20Panel%20System%20Infographic%20tanpa%20baterai.png', alt: 'Infografis Sistem Solar Panel Tanpa Baterai PowerX 1.300 Watt' },
      { type: 'h2', text: '5 blok utama sistem' },
      { type: 'ul', items: ['1. Solar Panel — 600 Wp per panel; rekomendasi 8 panel × 600 Wp = 4,8 kWp (Model PXPM006). Dengan 5 jam matahari puncak (PSH) menghasilkan ±24 kWh per hari (rata-rata).','2. Grid Tie / On-Grid Inverter — PXH6.6K-1PLVG1 6,6 kW 1-Phase, enclosure aluminium IP65, monitoring Wi-Fi, dan fitur zero export (opsional) untuk mengontrol aliran daya ke jaringan PLN.','3. Meter Listrik (kWh Meter) — tetap terpasang sebagai meteran PLN.','4. Panel Distribusi AC — membagi output inverter ke sirkuit beban rumah.','5. Beban Rumah — total 1.300 W: TV 100 W, Lampu 150 W, Kulkas 300 W, AC ½ PK 400 W, Mesin Cuci 250 W, Pompa Air 100 W, Router WiFi 20 W, Rice Cooker 300 W, Peralatan Lain 80 W.'] },
      { type: 'h2', text: 'Komponen sisi DC (Solar Panel)' },
      { type: 'ul', items: ['Kabel DC PV 4–6 mm² (merah & hitam) tahan UV','MC4 Connector','DC Combiner Box (terdapat MCB/SPD)','DC MCB atau Fuse'] },
      { type: 'h2', text: 'Komponen sisi AC (Output)' },
      { type: 'ul', items: ['AC MCB','SPD AC (surge protection device)','Kabel AC 3 × 6–10 mm²','Panel Distribusi'] },
      { type: 'h2', text: 'Estimasi produksi energi & penghematan' },
      { type: 'ul', items: ['Kapasitas sistem: 4,8 kWp (8 panel × 600 Wp)','Produksi energi: ±24 kWh per hari (rata-rata, asumsi PSH 5 jam/hari)','Estimasi penghematan listrik PLN: ±24 kWh per hari atau ±720 kWh per bulan','Hasil aktual tergantung lokasi, orientasi, dan kondisi cuaca'] },
      { type: 'h2', text: 'Keunggulan sistem tanpa baterai' },
      { type: 'ul', items: ['Mengurangi penggunaan listrik PLN di siang hari','Investasi lebih ekonomis (tanpa biaya baterai)','Instalasi lebih sederhana','Perawatan lebih mudah','Cocok untuk rumah dan kantor dengan penggunaan di siang hari'] },
      { type: 'quote', text: 'Catatan: Pada malam hari beban rumah dipenuhi oleh listrik PLN. Tersedia fitur zero export (opsional) agar tidak ada daya yang dikirim ke jaringan PLN. Jumlah panel dan kapasitas inverter dapat disesuaikan dengan kebutuhan beban dan luas atap.' },
      { type: 'cta', text: 'Konsultasi sistem solar tanpa baterai untuk rumah/kantor Anda', to: '/contact' },
    ],
  },
  {
    slug: 'membaca-istilah-teknis-sistem-solar-panel',
    tag: 'PANDUAN TEKNIS',
    category: 'panduan',
    tab: 'panduan-edukasi',
    group: 'solar-panel',
    featured: true,
    title: 'Membaca Istilah Teknis dalam Sistem Solar Panel — Wp, Voc, MPPT, SOC, LiFePO4, dan Lainnya',
    excerpt:
      'Panduan singkat memahami spesifikasi panel, inverter, baterai, dan jenis sistem — supaya Anda bisa membaca brosur dan proposal solar panel dengan percaya diri.',
    image:
      'https://customer-assets-eiarnc6j.emergentagent.net/job_ed34ddae-2acd-408a-97ce-e44390688f17/artifacts/3mdjvc7y_Panduan%20Istilah%20Teknis%20Solar%20Panel%20POWERX%20%281%29.png',
    author: 'Tim PowerX',
    date: '2026-10-03',
    read: '7 menit',
    body: [
      { type: 'p', text: 'Saat memilih sistem solar panel, Anda akan sering menemui istilah seperti Wp, Voc, MPPT, SOC, atau LiFePO4. Infografis berikut merangkum semua istilah penting di panel surya, inverter, baterai, hingga jenis sistem — plus rumus cepat agar Anda langsung bisa membaca spesifikasi dengan percaya diri.' },
      { type: 'image', src: 'https://customer-assets-eiarnc6j.emergentagent.net/job_ed34ddae-2acd-408a-97ce-e44390688f17/artifacts/3mdjvc7y_Panduan%20Istilah%20Teknis%20Solar%20Panel%20POWERX%20%281%29.png', alt: 'Infografis membaca istilah teknis dalam sistem solar panel PowerX' },
      { type: 'h2', text: '1. Istilah pada Panel Surya' },
      { type: 'ul', items: ['Wp — Daya puncak panel. Contoh: 600 Wp','Voc — Tegangan panel tanpa beban','Vmp / Vmpp — Tegangan kerja optimal panel','Isc — Arus hubung singkat maksimum','Imp / Impp — Arus kerja optimal panel','Series — Panel disusun untuk menaikkan tegangan','Parallel — Panel disusun untuk menaikkan arus'] },
      { type: 'h2', text: '2. Istilah pada Inverter' },
      { type: 'ul', items: ['Rated Power — Daya kerja nominal inverter','Peak / Surge Power — Daya sesaat untuk start beban','MPPT — Pengatur titik daya optimal panel','PV Input — Input dari panel surya ke inverter','Max PV Voltage — Batas tegangan DC maksimum','AC Input — Input listrik dari PLN / genset','AC Output — Output listrik ke beban','Efficiency — Efisiensi konversi daya'] },
      { type: 'h2', text: '3. Istilah pada Baterai (ESS)' },
      { type: 'ul', items: ['V (Volt) — Tegangan baterai','Ah — Kapasitas arus baterai','kWh — Kapasitas energi baterai','SOC — Persentase isi baterai (State of Charge)','DoD — Kapasitas yang boleh dipakai (Depth of Discharge)','BMS — Sistem proteksi & kontrol baterai','Cycle Life — Jumlah siklus isi / pakai baterai','LiFePO4 / LFP — Jenis baterai lithium yang umum untuk ESS'] },
      { type: 'h2', text: '4. Jenis Sistem' },
      { type: 'ul', items: ['On-Grid — Terhubung ke PLN','Off-Grid — Berdiri sendiri tanpa PLN','Hybrid — Gabungan panel, baterai, dan PLN','1 Fasa — Umum untuk rumah','3 Fasa — Umum untuk beban besar / komersial'] },
      { type: 'h2', text: '5. Rumus Cepat Membaca Spesifikasi' },
      { type: 'ul', items: ['1 kW = 1.000 W','1 kWh = energi 1.000 W selama 1 jam','Kapasitas baterai = V × Ah','Contoh baterai: 51,2 V × 100 Ah = 5.120 Wh = 5,12 kWh','Contoh panel: 10 panel × 600 Wp = 6.000 Wp = 6 kWp'] },
      { type: 'quote', text: 'Tips: kW = daya, kWh = energi, kWp = kapasitas puncak panel surya.' },
      { type: 'cta', text: 'Konsultasi sizing sistem solar panel', to: '/contact' },
    ],
  },
  {
    slug: 'cara-kerja-sistem-solar-panel',
    tag: 'SOLAR PANEL',
    category: 'edukasi',
    tab: 'panduan-edukasi',
    group: 'solar-panel',
    featured: false,
    title: 'Cara Kerja Sistem Solar Panel: Mengubah Sinar Matahari Menjadi Listrik untuk Rumah dan Bisnis Anda',
    excerpt:
      'Pahami alur lengkap sistem solar panel: panel menghasilkan listrik DC, inverter mengubahnya menjadi AC 220/380V, dan baterai menyimpan energi untuk malam hari atau saat PLN padam.',
    image:
      'https://customer-assets-eiarnc6j.emergentagent.net/job_ed34ddae-2acd-408a-97ce-e44390688f17/artifacts/ftu4r5ou_Cara%20kerja%20sistem%20solar%20panel.png',
    author: 'Tim PowerX',
    date: '2026-10-02',
    read: '5 menit',
    body: [
      { type: 'p', text: 'Bagaimana sinar matahari bisa menyalakan TV, AC, dan kulkas di rumah Anda? Infografis berikut menjelaskan alur kerja sistem solar panel secara sederhana — dari cahaya matahari hingga menjadi listrik yang siap pakai untuk rumah dan bisnis Anda.' },
      { type: 'image', src: 'https://customer-assets-eiarnc6j.emergentagent.net/job_ed34ddae-2acd-408a-97ce-e44390688f17/artifacts/ftu4r5ou_Cara%20kerja%20sistem%20solar%20panel.png', alt: 'Infografis cara kerja sistem solar panel PowerX' },
      { type: 'h2', text: '1. Solar Panel — Menghasilkan Listrik' },
      { type: 'ul', items: [
        'Mengubah energi matahari menjadi listrik DC (arus searah)',
        'Tidak menghasilkan polusi',
        'Sumber energi terbarukan dan gratis dari alam',
        'Tersedia berbagai kapasitas (150 Wp – 720 Wp)',
      ] },
      { type: 'h2', text: '2. Inverter — Mengatur & Mengubah Listrik' },
      { type: 'ul', items: [
        'Mengubah listrik DC menjadi AC 220/380V (arus bolak-balik)',
        'Mengatur aliran listrik antara solar panel, baterai, PLN dan beban',
        'Menjaga kestabilan tegangan dan frekuensi',
        'Pada hybrid inverter, dapat bekerja dengan panel, baterai dan PLN secara otomatis',
      ] },
      { type: 'h2', text: '3. Baterai — Menyimpan Energi' },
      { type: 'ul', items: [
        'Menyimpan kelebihan listrik dari solar panel',
        'Digunakan saat malam hari, mendung, atau PLN padam',
        'Tersedia berbagai kapasitas (5 kWh, 10 kWh, 15 kWh, dll)',
        'Teknologi baterai Lithium yang aman dan tahan lama',
      ] },
      { type: 'h2', text: '4. Beban / Peralatan & PLN (Opsional)' },
      { type: 'p', text: 'Listrik AC 220/380V dari inverter langsung mengalir ke seluruh peralatan rumah — TV, lampu, AC, kulkas, hingga mesin usaha. PLN tetap dapat digunakan sebagai sumber listrik tambahan atau cadangan saat produksi solar tidak mencukupi.' },
      { type: 'h2', text: 'Keuntungan Menggunakan Sistem Solar Panel' },
      { type: 'ul', items: [
        'Hemat biaya listrik bulanan',
        'Ramah lingkungan — tanpa emisi',
        'Tetap menyala saat listrik padam (dengan baterai)',
        'Mandiri energi dari matahari',
        'Nilai properti lebih tinggi',
      ] },
      { type: 'quote', text: 'Kesimpulan: Solar panel menghasilkan listrik, baterai menyimpan energi, dan inverter mengatur serta menyalurkan listrik untuk digunakan di rumah atau kantor Anda.' },
      { type: 'cta', text: 'Konsultasi sistem solar untuk rumah/bisnis Anda', to: '/contact' },
    ],
  },
  {
    slug: 'contoh-sistem-solar-hybrid-powerx-eah-6-6k',
    tag: 'STUDI KASUS',
    category: 'studi-kasus',
    tab: 'contoh-aplikasi',
    group: 'solar-panel',
    featured: true,
    title: 'Contoh Sistem Solar Hybrid PowerX PXH 6.6K: Backup 13 Jam untuk Rumah 1.300 Watt',
    excerpt:
      'Diagram lengkap sistem solar hybrid 1-fasa: 8 panel 600 Wp + inverter PXH 6.6K + 4 baterai LiFePO4 51,2V 100Ah — total 20,48 kWh dengan estimasi backup ±13 jam untuk beban rumah 1.300 W.',
    image:
      'https://customer-assets-eiarnc6j.emergentagent.net/job_ed34ddae-2acd-408a-97ce-e44390688f17/artifacts/46jvxl80_POWERX%20Solar%20Hybrid%20System%20Diagram.png',
    author: 'Tim Engineering PowerX',
    date: '2026-10-01',
    read: '8 menit',
    body: [
      { type: 'p', text: 'Ingin tahu persisnya apa saja yang Anda terima saat memesan paket solar hybrid PowerX? Diagram di bawah ini merinci setiap komponen — dari panel surya di atap, kabel DC, inverter, hingga panel distribusi AC yang masuk ke beban rumah — plus perhitungan backup-nya.' },
      { type: 'image', src: 'https://customer-assets-eiarnc6j.emergentagent.net/job_ed34ddae-2acd-408a-97ce-e44390688f17/artifacts/46jvxl80_POWERX%20Solar%20Hybrid%20System%20Diagram.png', alt: 'Diagram sistem solar hybrid PowerX PXH 6.6K untuk rumah 1.300 Watt' },
      { type: 'h2', text: '6 blok utama sistem' },
      { type: 'ul', items: [
        '1. Solar Panel — 8 × 600 Wp = 4,8 kWp (rekomendasi); dengan 5 jam matahari puncak (PSH) dapat mengisi baterai ±1 hari (sudah memperhitungkan losses).',
        '2. Hybrid Inverter — PowerX PXH 6.6K single-phase, enclosure aluminium IP65, layar sentuh besar, remote monitoring Wi-Fi, dan UPS transfer time 0 ms untuk beban kritis.',
        '3. Baterai LiFePO4 — 4 modul rack-mount 51,2 V / 100 Ah (POWERX by EAST), total 20,48 kWh nominal, komunikasi CAN/RS485.',
        '4. Meter listrik PLN — tetap terpasang untuk hybrid grid-tie / backup fallback.',
        '5. Panel Distribusi AC — MCB per sirkuit + SPD AC + kabel AC 3 × 6–10 mm² ke panel distribusi rumah.',
        '6. Beban Rumah — total kebutuhan ±1.300 W: TV 100 W, Lampu 150 W, Kulkas 300 W, AC ½ PK 400 W, Mesin Cuci 250 W, Pompa Air 100 W, Router Wi-Fi 20 W, Rice Cooker 300 W, Peralatan lain 80 W.',
      ] },
      { type: 'h2', text: 'Komponen sisi DC (dari panel ke inverter)' },
      { type: 'ul', items: [
        'Kabel DC PV 4–6 mm² (merah & hitam) tahan UV',
        'Konektor MC4 standar industri',
        'DC Combiner Box dengan MCB/SPD',
        'DC MCB atau Fuse di sisi inverter',
      ] },
      { type: 'h2', text: 'Komponen sisi AC (dari inverter ke beban)' },
      { type: 'ul', items: [
        'AC MCB per sirkuit beban',
        'SPD AC (surge protection device)',
        'Kabel AC 3 × 6–10 mm² sesuai arus beban',
        'Panel Distribusi akhir di dalam rumah',
      ] },
      { type: 'h2', text: 'Perhitungan estimasi backup' },
      { type: 'ul', items: [
        'Kapasitas baterai nominal: 20,48 kWh (4 × 5,12 kWh)',
        'Depth of Discharge (DoD): 90%',
        'Energi yang dapat digunakan: 18,43 kWh',
        'Efisiensi inverter: ±93%',
        'Energi ke beban: ±17,15 kWh',
        'Beban rumah rata-rata: 1,3 kW',
        'Estimasi backup: ±13 jam',
      ] },
      { type: 'quote', text: 'Pada kapasitas 100% teoretis, backup dapat mencapai ±15,8 jam. Waktu backup di lapangan dapat berbeda tergantung jenis beban, pola pemakaian, dan kondisi sistem.' },
      { type: 'cta', text: 'Minta desain sistem solar hybrid untuk rumah Anda', to: '/contact' },
    ],
  },
  {
    slug: 'panduan-sistem-backup-rumah-12-jam',
    tag: 'PANDUAN',
    category: 'panduan',
    tab: 'panduan-edukasi',
    group: 'solar-panel',
    featured: true,
    title: 'Panduan Sederhana: Sistem Backup Listrik Rumah 12 Jam',
    excerpt:
      'Hitung kebutuhan inverter, jumlah baterai LiFePO4 51,2V 100Ah, dan panel surya 600 Wp untuk backup penuh 12 jam — mulai 450 VA sampai 7.700 VA.',
    image:
      '/api/images/powerx/admin/articles/396d816e2c2345e0b1bc7d404517ecaa.png',
    author: 'Tim Engineering PowerX',
    date: '2026-09-28',
    read: '6 menit',
    body: [
      { type: 'p', text: 'Berapa inverter, baterai, dan panel surya yang Anda butuhkan supaya rumah tetap menyala penuh 12 jam saat PLN padam? Infografis di bawah ini merangkum simulasinya untuk delapan golongan daya PLN yang paling umum di Indonesia — dari rumah subsidi 450 VA sampai rumah besar 7.700 VA tiga-fasa.' },
      { type: 'image', src: '/api/images/powerx/admin/articles/396d816e2c2345e0b1bc7d404517ecaa.png', alt: 'Panduan Sistem Backup Listrik Rumah 12 Jam PowerX' },
      { type: 'h2', text: 'Asumsi perhitungan' },
      { type: 'ul', items: [
        'Waktu backup target: 12 jam penuh',
        'Baterai lithium 51,2V 100Ah = 5,12 kWh / unit (energi efektif 4,2 kWh/unit setelah DoD 80% & efisiensi inverter)',
        'Panel surya 600 Wp / panel',
        'Perhitungan menggunakan beban penuh sesuai daya kontrak PLN',
      ] },
      { type: 'h2', text: 'Rekomendasi berdasarkan daya rumah' },
      { type: 'p', text: 'Tabel infografis sudah menjabarkan jumlah inverter, baterai, dan panel. Contoh kalkulasi: rumah 2.200 VA dengan pemakaian rata-rata 1.000 W selama 12 jam membutuhkan 1 inverter 1,5–2 kW + 3 baterai 5,12 kWh + 7 panel 600 Wp. Semakin besar beban dan semakin lama durasi backup, semakin besar sistem yang dibutuhkan.' },
      { type: 'quote', text: 'Tabel ini adalah simulasi beban penuh (maksimum). Jika pemakaian nyata Anda lebih kecil, kebutuhan baterai dan panel bisa lebih sedikit — hubungi tim engineer kami untuk sizing presisi.' },
      { type: 'cta', text: 'Minta sizing gratis untuk rumah Anda', to: '/contact' },
    ],
  },
  {
    slug: 'pilihan-daya-pln-rumah-usaha-industri',
    tag: 'EDUKASI',
    category: 'edukasi',
    tab: 'panduan-edukasi',
    group: 'solar-panel',
    featured: true,
    title: 'Pilihan Daya Listrik PLN untuk Rumah, Usaha, dan Industri',
    excerpt:
      'Daya 450 VA sampai 53.000 VA — pahami perbedaan 1 fasa vs 3 fasa, kebutuhan MCB, serta checklist upgrade dari 1 fasa ke 3 fasa.',
    image:
      'https://customer-assets-eiarnc6j.emergentagent.net/job_ed34ddae-2acd-408a-97ce-e44390688f17/artifacts/hncfavkh_POWERX%20PLN%20Electricity%20Options%20Guide.png',
    author: 'Tim Engineering PowerX',
    date: '2026-09-27',
    read: '7 menit',
    body: [
      { type: 'p', text: 'Memilih daya PLN yang tepat sejak awal menghemat biaya instalasi, mencegah MCB sering turun, dan membuat sistem inverter/UPS Anda bekerja optimal. Infografis berikut membandingkan 15 golongan daya PLN dari 450 VA sampai 53.000 VA, lengkap dengan arus MCB utama dan rekomendasi penggunaan.' },
      { type: 'image', src: 'https://customer-assets-eiarnc6j.emergentagent.net/job_ed34ddae-2acd-408a-97ce-e44390688f17/artifacts/hncfavkh_POWERX%20PLN%20Electricity%20Options%20Guide.png', alt: 'Pilihan Daya Listrik PLN untuk Rumah, Usaha, dan Industri PowerX' },
      { type: 'h2', text: '1 Fasa (230 V) vs 3 Fasa (230/400 V)' },
      { type: 'ul', items: [
        '1 Fasa: jalur utama L + N, tegangan ±230 V, cocok rumah tinggal 450–11.000 VA.',
        '3 Fasa: jalur utama R + S + T + N, tegangan 230 V fasa-netral & 400 V antar-fasa, cocok rumah besar / usaha / industri 13.200–53.000 VA.',
        'Peralatan 1 fasa 230 V tetap bisa dipakai pada sistem 3 fasa (fasa ke netral).',
        'Motor 3 fasa, mesin produksi, lift, dan AC central hanya bisa langsung di sistem 3 fasa.',
      ] },
      { type: 'h2', text: 'Upgrade dari 1 fasa ke 3 fasa — yang perlu disiapkan' },
      { type: 'ul', items: [
        'Penggantian kWh meter dan pembatas PLN ke sistem 3 fasa',
        'Kabel incoming (R, S, T, N) sesuai kapasitas daya baru',
        'Panel listrik dengan main breaker + proteksi (MCCB/MCB, RCD/RCBO, SPD)',
        'Pembagian beban 1 fasa diseimbangkan antar R, S, dan T',
        'Grounding/PE sesuai standar',
        'Jika memakai solar PowerX: pilih inverter 1-fasa atau 3-fasa yang sesuai',
      ] },
      { type: 'cta', text: 'Konsultasi sizing inverter & panel surya', to: '/contact' },
    ],
  },
  {
    slug: 'perbedaan-ups-online-line-interactive-standby',
    tag: 'UPS',
    category: 'edukasi',
    tab: 'panduan-edukasi',
    group: 'ups',
    title: 'Perbedaan UPS Online, Line-Interactive, dan Standby — Mana yang Tepat?',
    excerpt:
      'Zero transfer time, AVR built-in, atau sekadar backup singkat — kenali tiga topologi UPS agar tidak over-spec atau under-protect.',
    image:
      'https://images.unsplash.com/photo-1635335874521-7987db781153?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2NzV8MHwxfHNlYXJjaHwyfHxlbGVjdHJpY2FsJTIwZXF1aXBtZW50fGVufDB8fHx8MTc4MDcyNDgzNHww&ixlib=rb-4.1.0&q=85',
    author: 'Andi Pratama',
    date: '2026-09-20',
    read: '5 menit',
    body: [
      { type: 'p', text: 'Tiga topologi UPS yang paling umum di pasar punya karakter yang sangat berbeda. Memilihnya tanpa memahami bedanya bisa membuat Anda membayar terlalu mahal — atau lebih buruk, beban kritis Anda sebenarnya tidak terlindungi.' },
      { type: 'h2', text: 'Standby (Offline) UPS' },
      { type: 'p', text: 'Paling murah. Beban dialiri langsung dari PLN; UPS baru aktif saat listrik padam, dengan transfer time ~4–10 ms. Cocok untuk PC rumahan dan router — tapi tidak disarankan untuk server, peralatan medis, atau PLC industri.' },
      { type: 'h2', text: 'Line-Interactive UPS' },
      { type: 'p', text: 'Ada AVR (Automatic Voltage Regulation) built-in, sehingga tegangan PLN yang naik-turun dikoreksi tanpa pindah ke baterai. Transfer time masih ada (~2–4 ms). Sweet spot untuk kantor, kasir, CCTV, dan rak jaringan kecil.' },
      { type: 'h2', text: 'Online Double-Conversion UPS' },
      { type: 'p', text: 'Beban selalu dialiri dari inverter (AC → DC → AC). Zero transfer time, PF murni, dan proteksi penuh dari semua gangguan daya. Wajib untuk data center, server kritis, lab, dan rumah sakit. Harga 2–3× line-interactive, tapi mencegah downtime yang jauh lebih mahal.' },
      { type: 'cta', text: 'Lihat katalog UPS PowerX', to: '/products?category=ups' },
    ],
  },
  {
    slug: 'baterai-lifepo4-vs-vrla',
    tag: 'BATERAI',
    category: 'edukasi',
    tab: 'panduan-edukasi',
    group: 'ups',
    title: 'Baterai LiFePO4 vs VRLA: Perbandingan Jujur untuk Sistem Backup Modern',
    excerpt:
      'Siklus hidup 10× lebih panjang, bobot 3× lebih ringan, dan BMS pintar — apakah LiFePO4 sudah masuk akal untuk gedung Anda?',
    image:
      'https://images.pexels.com/photos/9875416/pexels-photo-9875416.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940',
    author: 'Maria Lim',
    date: '2026-09-15',
    read: '6 menit',
    body: [
      { type: 'p', text: 'VRLA (Valve-Regulated Lead-Acid) sudah puluhan tahun jadi tulang punggung UPS. Tapi LiFePO4 kini turun ke harga yang membuatnya ekonomis — bukan hanya untuk solar, tapi juga untuk ruang server dan backup gedung.' },
      { type: 'h2', text: 'Perbandingan singkat' },
      { type: 'ul', items: [
        'Siklus: VRLA ±500 siklus (DoD 50%) vs LiFePO4 >3.500 siklus (DoD 80%).',
        'Bobot per kWh: VRLA ±30 kg vs LiFePO4 ±10 kg.',
        'Rentang suhu operasi: VRLA 20–25°C ideal vs LiFePO4 -15–55°C.',
        'Monitoring: VRLA perlu alat eksternal; LiFePO4 BMS bawaan, bisa CAN/RS485 ke inverter.',
        'TCO 10 tahun: LiFePO4 biasanya lebih murah karena tidak perlu diganti 2×.',
      ] },
      { type: 'h2', text: 'Kapan VRLA masih masuk akal?' },
      { type: 'p', text: 'Untuk aplikasi UPS tower kecil (<3 kVA) dengan runtime pendek <15 menit, VRLA tetap pilihan ekonomis karena harga unit awalnya rendah dan standar modul UPS. Di atas itu, hampir selalu LiFePO4 menang di total biaya kepemilikan.' },
      { type: 'cta', text: 'Lihat baterai LiFePO4 PowerX', to: '/products?category=battery&sub=battery-lifepo4-rack' },
    ],
  },
  {
    slug: 'memilih-inverter-hybrid-5-hal',
    tag: 'INVERTER',
    category: 'panduan',
    tab: 'panduan-edukasi',
    group: 'solar-panel',
    title: 'Memilih Inverter Hybrid: 5 Hal yang Wajib Diperiksa Sebelum Beli',
    excerpt:
      'MPPT, battery compatibility, generator input, IP rating, hingga protokol komunikasi — checklist supaya Anda tidak terkunci di satu merek baterai saja.',
    image:
      'https://images.pexels.com/photos/7867332/pexels-photo-7867332.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940',
    author: 'Budi Hartono',
    date: '2026-09-10',
    read: '5 menit',
    body: [
      { type: 'p', text: 'Inverter hybrid adalah jantung sistem solar + baterai Anda. Satu pilihan salah di awal bisa membuat Anda terkunci dengan merek baterai tertentu, atau membayar lebih untuk fitur yang tidak dipakai.' },
      { type: 'h2', text: '1. Jumlah dan rating MPPT' },
      { type: 'p', text: 'Dua MPPT independen memungkinkan Anda memasang panel dengan orientasi berbeda tanpa kehilangan daya. Perhatikan Max PV Voltage, Max PV Current per MPPT, dan efisiensi tracking (minimal 99%).' },
      { type: 'h2', text: '2. Battery compatibility & protokol' },
      { type: 'p', text: 'Pastikan inverter mendukung tegangan baterai Anda (48V LV atau HV 300–600V) dan protokol BMS yang digunakan (CAN/RS485). Inverter yang hanya mendukung protokol proprietary akan mengunci Anda ke satu merek baterai.' },
      { type: 'h2', text: '3. Generator / backup input' },
      { type: 'p', text: 'Untuk area yang sering mati listrik berjam-jam, generator input (dengan auto-start kontrol) sangat berharga. Pastikan inverter mendukung dry contact relay untuk ATS.' },
      { type: 'h2', text: '4. IP rating & lokasi pasang' },
      { type: 'p', text: 'Inverter outdoor minimal IP65. Inverter indoor IP20 cukup, tapi perhatikan ventilasi dan suhu lingkungan — derating mulai 40°C.' },
      { type: 'h2', text: '5. Monitoring & update firmware' },
      { type: 'p', text: 'App monitoring real-time (WiFi/4G) wajib untuk troubleshooting jarak jauh. OTA update firmware adalah bonus — tanda vendor serius jangka panjang.' },
      { type: 'cta', text: 'Lihat inverter hybrid PowerX & Growatt', to: '/products?category=inverter&sub=inverter-hybrid' },
    ],
  },
  {
    slug: 'lampu-jalan-tenaga-surya-all-in-one',
    tag: 'SOLAR LIGHT',
    category: 'produk',
    tab: 'panduan-edukasi',
    group: 'solar-light',
    title: 'Lampu Jalan Tenaga Surya All-in-One: Keunggulan & Kapan Memilih Split-Type',
    excerpt:
      'All-in-One memangkas biaya instalasi 60% karena tidak perlu kabel. Tapi untuk tiang tinggi di jalan protokol, Split-Type masih juara.',
    image:
      'https://customer-assets-eiarnc6j.emergentagent.net/job_ed34ddae-2acd-408a-97ce-e44390688f17/artifacts/ofo6d1ep_1.Sistem%20lampu%20jalan%20tenaga%20surya.jpg',
    author: 'Tim Engineering PowerX',
    date: '2026-09-05',
    read: '4 menit',
    body: [
      { type: 'p', text: 'Lampu jalan tenaga surya terbagi dua tipe: All-in-One (panel + baterai + lampu + controller menyatu) dan Split-Type (panel terpisah di atas, baterai di dalam cabinet). Keduanya punya use-case yang jelas.' },
      { type: 'h2', text: 'Kelebihan All-in-One' },
      { type: 'ul', items: [
        'Instalasi 1 orang 15 menit — hanya pasang bracket di tiang.',
        'Tanpa kabel panel ke baterai → tanpa risiko pencurian kabel.',
        'IP66, cocok lingkungan pesisir dan tropis.',
        'Harga per titik 40–60% lebih murah dari Split-Type setara.',
      ] },
      { type: 'h2', text: 'Kapan tetap pilih Split-Type' },
      { type: 'p', text: 'Untuk jalan protokol dengan tiang 10–12 m yang butuh lumen tinggi (>12.000 lm), panel surya besar harus terpisah supaya tidak membebani tiang dan supaya baterai bisa diperbesar tanpa bikin head unit berat.' },
      { type: 'cta', text: 'Lihat katalog lampu jalan tenaga surya', to: '/products?category=smart-solar-light' },
    ],
  },
  {
    slug: 'ess-untuk-pabrik-peak-shaving',
    tag: 'ESS',
    category: 'studi-kasus',
    tab: 'contoh-aplikasi',
    group: 'ups',
    title: 'ESS untuk Pabrik: ROI dari Peak-Shaving dan Load-Shifting',
    excerpt:
      'Studi kasus pabrik tekstil 2 MW: ESS 500 kWh memangkas tagihan listrik 18% dalam 11 bulan — paybacknya 4,2 tahun.',
    image:
      'https://images.pexels.com/photos/9875416/pexels-photo-9875416.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940',
    author: 'Tim Engineering PowerX',
    date: '2026-08-30',
    read: '7 menit',
    body: [
      { type: 'p', text: 'Pabrik tekstil 2 MW di Jawa Barat mengalami tagihan listrik melonjak karena WBP (Waktu Beban Puncak) 17.00–22.00 — tarifnya 1,4× tarif normal. Kami pasang ESS PowerX 500 kWh dengan skema peak-shaving.' },
      { type: 'h2', text: 'Skema operasi' },
      { type: 'ul', items: [
        'Charge: pukul 22.00–05.00 dengan tarif LWBP termurah.',
        'Discharge: pukul 17.00–22.00 untuk menutup puncak demand.',
        'Idle & standby di jam lain untuk cadangan outage.',
      ] },
      { type: 'h2', text: 'Hasil setelah 11 bulan' },
      { type: 'ul', items: [
        'Tagihan listrik turun 18% (dari rata-rata Rp 1,8 M/bulan menjadi Rp 1,47 M/bulan).',
        'Payback dihitung ulang: 4,2 tahun (semula estimasi 5 tahun).',
        'Bonus: 2× outage PLN berjalan tanpa downtime karena ESS otomatis UPS mode.',
      ] },
      { type: 'quote', text: 'Hitungan ROI sangat tergantung profil beban. PowerX menyediakan simulasi gratis — kirim profil 15-menit meter listrik Anda, kami buatkan proyeksi 10 tahun.' },
      { type: 'cta', text: 'Minta simulasi ROI ESS untuk pabrik Anda', to: '/contact' },
    ],
  },
];

export const stories = articles.slice(0, 3).map((a, i) => ({
  id: i + 1,
  slug: a.slug,
  tag: a.tag,
  title: a.title,
  excerpt: a.excerpt,
  image: a.image,
}));

export const testimonials = [
  {
    name: 'Andi Pratama',
    role: 'IT Manager, PT Sinar Mas Data',
    quote:
      'Setelah 4 tahun memakai PowerX 30KVA, downtime kami praktis nol. Service-nya juga responsif.',
  },
  {
    name: 'Maria Lim',
    role: 'Owner, Klinik Sehat Bersama',
    quote:
      'Peralatan medis kami sangat sensitif. PowerX memberi ketenangan luar biasa.',
  },
  {
    name: 'Budi Hartono',
    role: 'Project Engineer, EPC Energy',
    quote:
      'Tim teknis PowerX membantu desain instalasi inverter hybrid 5KW di proyek rural electrification kami.',
  },
];

export const formatIDR = (n) =>
  new Intl.NumberFormat('id-ID', {
    style: 'currency',
    currency: 'IDR',
    maximumFractionDigits: 0,
  }).format(n);

export const priceLabel = (p) =>
  p == null ? 'Minta Penawaran' : formatIDR(p);
